import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7b86dd72&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b86dd72')) {
      api.createRecord('7b86dd72', component.options)
    } else {
      api.reload('7b86dd72', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7b86dd72&", function () {
      api.rerender('7b86dd72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw_requests/index.vue"
export default component.exports